import { render, staticRenderFns } from "./LegacyColumnSelectionComponent.vue?vue&type=template&id=2d7796ee&"
import script from "./LegacyColumnSelectionComponent.vue?vue&type=script&lang=ts&"
export * from "./LegacyColumnSelectionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7796ee')) {
      api.createRecord('2d7796ee', component.options)
    } else {
      api.reload('2d7796ee', component.options)
    }
    module.hot.accept("./LegacyColumnSelectionComponent.vue?vue&type=template&id=2d7796ee&", function () {
      api.rerender('2d7796ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/models/Table/Legacy/LegacyColumnSelectionComponent.vue"
export default component.exports